









































































































































































































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import Alert from '@/components/Shared/Alert.vue';
import ajax from '@/lib/ajax';
import { AppModule } from '@/store/modules/app';
import { CVParseResult } from '@/models/CVParser/CVParseResult';

@Component({
  name: 'CVParserTest',
  components: { Alert }
})
export default class CVParserTest extends GiganautVue {
  private file: File | null = null;
  private uploading = false;
  private result: CVParseResult | null = null;
  private error: string | null = null;

  clearResults() {
    this.result = null;
    this.error = null;
  }

  async parseCV() {
    if (!this.file) return;

    this.uploading = true;
    this.error = null;
    this.result = null;

    try {
      // Create form data
      const formData = new FormData();
      formData.append('file', this.file);

      // Upload and parse
      const response = await ajax.post('/api/v1/agency/test/parse-cv', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 120000 // 2 minute timeout
      });

      this.result = response.data as CVParseResult;

    } catch (error) {
      console.error('Failed to parse CV:', error);
      this.error = 'Failed to parse CV. Please check the file format and try again.';
      AppModule.handleApiError(error);
    } finally {
      this.uploading = false;
    }
  }
}
